import { Component, computed, signal, viewChild } from '@angular/core';
import { OrderStepBaseComponent } from 'app/order/order-step-base-component';
import {
    QuestionItem,
    ProductAdviceComponent,
} from '../../../../order/components/product-advice/product-advice.component';
import { OrderState } from 'app/order/models';
import { ProductAdviceAnswers } from '@models/product-advice';
import { ProductAdviceResultBoxComponent } from 'app/order/components/product-advice-result-box/product-advice-result-box.component';

const tabletQuestionItems: QuestionItem[] = [
    {
        controlName: 'TABLET_Q1',
        question: 'Für wen und in welchem schulischen Zusammenhang wird das Gerät genutzt?',
        answerOptions: [
            { label: 'Schüler – schulisch bereitgestellt', value: 'STUDENT_SCHOOL_DEVICE' },
            { label: 'Schüler – eigenes Gerät für schulische Nutzung', value: 'STUDENT_OWN_DEVICE' },
            {
                label: 'Lehrkraft – bereitgestelltes oder eigenes schulisch genutztes Gerät',
                value: 'TEACHER_SCHOOL_DEVICE',
            },
            { label: 'Kein schulischer Zusammenhang', value: 'NO_SCHOOL_CONTEXT' },
        ],
    },
    {
        controlName: 'TABLET_Q2',
        question: 'Welches Gerät soll abgesichert werden?',
        answerOptions: [
            { label: 'Tablet, Laptop, Notebook, Convertible oder vergleichbares Gerät', value: 'ELIGIBLE_DEVICE' },
            { label: 'Mobiltelefon oder Smartphone', value: 'SMARTPHONE' },
            { label: 'Anderes Gerät', value: 'OTHER_DEVICE' },
        ],
    },
    {
        controlName: 'TABLET_Q3',
        question: 'Was möchten Sie mit der Versicherung vor allem absichern?',
        answerOptions: [
            { label: 'Schäden am Gerät', value: 'DAMAGE_ONLY' },
            { label: 'Schäden sowie Diebstahl / Raub', value: 'DAMAGE_AND_THEFT' },
        ],
    },
];

@Component({
    selector: 'app-product-advice-tablet',
    templateUrl: './product-advice-tablet.component.html',
    imports: [ProductAdviceComponent, ProductAdviceResultBoxComponent],
})
export class ProductAdviceTabletComponent extends OrderStepBaseComponent {
    private readonly adviceComponent = viewChild(ProductAdviceComponent);

    protected questions = tabletQuestionItems;

    private initialInsuranceTypeId: number;
    protected recommendedInsuranceTypeId: number;

    public constructor() {
        super();
    }

    protected formAnswers = signal<ProductAdviceAnswers>({});
    protected showAdvice = signal<boolean>(false);

    protected wrongInsurance = computed<boolean | null>(
        () =>
            this.formAnswers().TABLET_Q1 === 'NO_SCHOOL_CONTEXT' ||
            this.formAnswers().TABLET_Q2 === 'SMARTPHONE' ||
            this.formAnswers().TABLET_Q2 === 'OTHER_DEVICE',
    );

    protected evaluateAdvice(adviceChange: { answers: ProductAdviceAnswers; complete: boolean }): void {
        this.formAnswers.set(adviceChange.answers);

        if (!adviceChange.complete) {
            this.showAdvice.set(false);
            return;
        }

        this.initialInsuranceTypeId = this.insuranceType().id;
        this.recommendedInsuranceTypeId = this.insuranceType().id;

        this.showAdvice.set(true);
    }

    public getData(): Partial<OrderState> {
        const formData = this.adviceComponent().getData();

        if (formData.advice.mode === 'WAIVER') {
            return formData;
        }

        return {
            advice: {
                ...formData.advice,
                initialInsuranceTypeId: this.initialInsuranceTypeId,
                recommendedInsuranceTypeId: this.recommendedInsuranceTypeId,
                resultDecision: 'CONFIRMED_MATCH',
            },
        };
    }
}
